// extracted by mini-css-extract-plugin
export var agreement = "CorporateForm-module--agreement--22775";
export var bookingText = "CorporateForm-module--bookingText--766bc";
export var fadeInAnimation = "CorporateForm-module--fadeInAnimation--106c4";
export var hide = "CorporateForm-module--hide--0d41d";
export var hideOnMobile = "CorporateForm-module--hideOnMobile--21f80";
export var scheduleButtonMobile = "CorporateForm-module--scheduleButtonMobile--88705";
export var sendButton = "CorporateForm-module--sendButton--20e2a";
export var submitWrap = "CorporateForm-module--submitWrap--8dff0";